import api from './api';

const itemSetsService = {
  // Get all item sets for the current company
  getItemSets: async () => {
    try {
      const response = await api.get('/item-sets');
      return response.data;
    } catch (error) {
      throw error.response?.data || { error: 'Failed to fetch item sets' };
    }
  },

  // Get a single item set by ID
  getItemSet: async (id) => {
    try {
      const response = await api.get(`/item-sets/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || { error: 'Failed to fetch item set' };
    }
  },

  // Create a new item set
  createItemSet: async (itemSetData) => {
    try {
      const response = await api.post('/item-sets', itemSetData);
      return response.data;
    } catch (error) {
      throw error.response?.data || { error: 'Failed to create item set' };
    }
  },

  // Update an existing item set
  updateItemSet: async (id, itemSetData) => {
    try {
      const response = await api.put(`/item-sets/${id}`, itemSetData);
      return response.data;
    } catch (error) {
      throw error.response?.data || { error: 'Failed to update item set' };
    }
  },

  // Delete an item set
  deleteItemSet: async (id) => {
    try {
      const response = await api.delete(`/item-sets/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || { error: 'Failed to delete item set' };
    }
  }
};

export default itemSetsService;



